import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Doesn't barf on invalid numbers
 */
@Pipe({
  name: 'safeNumber'
})
export class SafeNumberPipe implements PipeTransform {
  public transform(value: number | string, format: string): any {
    try {
      const strVal = value.toString().replace(/,/g, '');
      return formatNumber(+strVal, 'en-GB', format);
    } catch {
      return value;
    }
  }
}
